<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
    left
    class="primary"
    dark
  >
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        :to="item.route"
        v-if="showMenuItem(item)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      
      <v-divider></v-divider>

      <v-list-item two-line v-if="isAdmin">
        <v-list-item-avatar>
          <img src="https://brodelec.fr/images/user-account-icon.png">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ chosenCustomer }}</v-list-item-title>
          <v-list-item-subtitle>Client sélectionné</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      
      <v-divider></v-divider>

      <v-list-item
        v-if="isAuthenticated"
        link
        @click.stop="logout()"
      >
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Déconnexion</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-else
        link
        :to="{ name: 'Login' }"
      >
        <v-list-item-icon>
          <v-icon>mdi-lock</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Se connecter</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // EVENTS
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { SET_LEFT_MENU_VISIBILITY } from '@/store/actions/general'
  // VUEX
  import { mapGetters } from 'vuex'

  export default {
    name: 'Sidebar',

    data: () => ({
      items: [
        { 
          id: 'collections',
          title: 'Collections', 
          icon: 'mdi-image-multiple', 
          route: { name: 'ListReference' }, 
          auth: true ,
          admin: false,
        },
        { 
          id: 'orders',
          title: 'Commandes', 
          icon: 'mdi-shopping', 
          route: { name: 'ListOrder' }, 
          auth: true,
          admin: false
        },
        { 
          id: 'choose-customer',
          title: 'Choisir client', 
          icon: 'mdi-account', 
          route: { name: 'ChooseCustomer' }, 
          auth: true,
          admin: true
        },
      ]
    }),
    
    computed: {
      ...mapGetters({
        isAuthenticated: 'isAuthenticated',
        isAdmin: 'isAdmin',
      }),
      drawer: {
        get() {
          return this.$store.getters.isleftMenuShown
        },
        set(value) {
          this.$store.commit(SET_LEFT_MENU_VISIBILITY, value)
        },
      },
      chosenCustomer() {
        let string = ''
        if (this.$store.getters.isAdmin && this.$store.getters.hasCustomer) {
          string = this.$store.getters.getCustomer.text
        }

        return string
      },
    },

    methods: {
      logout() {
        this.$store.dispatch(AUTH_LOGOUT)
          .then(() => {
            this.$router.push('/login')
          })
      },
      showMenuItem(item) {
        if (item.auth) {
          if (item.admin) {
            return this.isAdmin
          }

          return this.isAuthenticated
        }

        return true
      }
    },
  }
</script>